export const simulation = {
    title: 'Simulation',

    tableCompanyName: 'Company Name',
    tableTitle: 'table',

    valueChainLabel: 'Value Chain',
    naceLabel: 'Process',
    usLabel: 'Industry Classification',
    ipcLabel: 'Select a Cluster',

    ecoSystemGroupCompanies: 'Group Companies',
    ecoSystemEcosystem: 'Ecosystem',
    ecoSystemDefault: 'Default',
    modeselect: 'Select Mode',

    selectTable: 'Simulation Target List',
    selectTableCompanyName: 'Company',
    selectTableCompanyNameAllianceBenefit: 'Alliance Benefit',
    selectTableScore: 'Score',
    selectTableImpact: 'Impact',
    selectTableScale: 'Revenue [k USD]',
    selectTableMarketability: 'Minority Investment Amount [m JPY]',
    selectTableFoundationFiscalYear: 'Foundation Year',
    selectTableStartupPhase: 'Startup Stages',

    chart: 'Synergy Analysis - Innovation',
    pre: 'Pre-Alliance',
    post: 'Post-Alliance',
    yAxis: 'yAxis',

    type: 'Type',
    selectCompanyPost: 'Selected Company (Post-Alliance)',
    selectCompanyPre: 'Selected Company (Pre-Alliance)',
    otherCompany: 'Other Company',
    selectedCompanyWithLabel: 'Selected Company With Label',

    themeTableTitle: "Synergy Analysis - Company's Affinity with Theme",
    themeTableCompanyName: 'Company',
    themeTableRankPre: 'Ranking (Pre-Alliance)',
    themeTableRankPost: 'Ranking (Post-Alliance)',
    themeTableAffinityPre: 'Affinity with Company (Pre-Alliance)',
    themeTableAffinityPost: 'Affinity with Company (Post-Alliance)',
    themeTableAffinityDiff: 'Affinity with Company (Diff)',

    companyTableTitle: "Synergy Analysis - Theme's Affinity with Company",
    companyTableThemeName: 'Theme',
    companyTableRankPre: 'Ranking (Pre-Alliance)',
    companyTableRankPost: 'Ranking (Post-Alliance)',
    companyTableAffinityPre: 'Affinity with Company (Pre-Alliance)',
    companyTableAffinityPost: 'Affinity with Company (Post-Alliance)',
    companyTableAffinityDiff: 'Affinity with Company (Diff)',
    companyTableAmountPre: 'Minority Investment Amount [m JPY] (Pre-Alliance)',
    companyTableAmountPost: 'Minority Investment Amount [m JPY] (Post-Alliance)',

    // Switch btn and RadioGroup
    CompanySelectMode: 'Company Select',
    LabelFixMode: 'Label Fix',
    labelShowMore: 'Company Name, PatentCount',
    labelShowOnlyCluster: 'Company Name only'
}
